import { render, staticRenderFns } from "./custom_message.vue?vue&type=template&id=37fb240e&scoped=true&"
import script from "./custom_message.vue?vue&type=script&lang=ts&"
export * from "./custom_message.vue?vue&type=script&lang=ts&"
import style0 from "./custom_message.vue?vue&type=style&index=0&id=37fb240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb240e",
  null
  
)

export default component.exports